/** Shared TinyMCE-style typography for section preview iframes (matches DocumentEditor content_style). */
export const EDITOR_PREVIEW_CSS = `
body {
	font-family: "Times New Roman", Times, serif;
	font-size: 12pt;
	line-height: 2;
	color: #111;
	margin: 0 auto;
	padding: 96px;
	max-width: 794px;
	box-sizing: border-box;
	background: #fff;
}
.wf-section-guide-intro { margin: 0 0 1em 0; font-style: italic; color: #374151; }
p, h1, h2, h3, h4, h5, h6 { margin: 0; padding: 0; }
p { text-indent: 0.5in; }
h1 { font-size: 12pt !important; font-weight: bold !important; line-height: 2 !important; text-align: center; }
h2 { font-size: 12pt !important; font-weight: bold !important; line-height: 2 !important; text-align: left; }
h2.wf-level1-heading { text-align: center !important; }
p.wf-keywords-line { text-indent: 0.5in !important; margin-top: 0; }
h3 { font-size: 12pt !important; font-weight: bold !important; font-style: italic !important; line-height: 2 !important; text-align: left; }
h4, h5, h6 { font-size: 12pt !important; line-height: 2 !important; }
p.wf-no-indent, .wf-scaffold p, td p, th p, li p, blockquote p,
h1 + p, h2 + p, h3 + p, h4 + p, h5 + p, h6 + p,
div.page-break-before > p:first-of-type, .wf-abstract-wrap p { text-indent: 0; }
blockquote { margin: 0.5em 0 0.5em 0.5in; font-size: 12pt; line-height: 2; border-left: none; padding-left: 0; }
.wf-title-page p.ql-align-center, p.ql-align-center { text-align: center; text-indent: 0; }
.wf-export-omit { display: none; }
img { max-width: 100%; height: auto; }
table { border-collapse: collapse; }
.page-break-before { page-break-before: always; break-before: page; border-top: 2px dashed #d1d5db; margin-top: 3rem; padding-top: 3rem; }
`;

export const SECTION_GUIDE_PREVIEW_CSS = `
body {
	font-family: "Times New Roman", Times, serif;
	font-size: 12pt;
	line-height: 1.5;
	color: #111;
	margin: 24px;
}
.wf-section-guide-intro { margin: 0 0 1em 0; font-style: italic; color: #374151; }
img { max-width: 100%; height: auto; }
table { border-collapse: collapse; }
`;
